import { render, staticRenderFns } from "./CustomExam.vue?vue&type=template&id=2976bd0e&"
import script from "./CustomExam.vue?vue&type=script&lang=ts&"
export * from "./CustomExam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports